import { render, staticRenderFns } from "./OrmQuoteItems.vue?vue&type=template&id=3a79354e&scoped=true"
import script from "./OrmQuoteItems.vue?vue&type=script&lang=js"
export * from "./OrmQuoteItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a79354e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a79354e')) {
      api.createRecord('3a79354e', component.options)
    } else {
      api.reload('3a79354e', component.options)
    }
    module.hot.accept("./OrmQuoteItems.vue?vue&type=template&id=3a79354e&scoped=true", function () {
      api.rerender('3a79354e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/utilities/orm/components/OrmQuoteItems.vue"
export default component.exports